module.exports = __webpack_public_path__ + "static/media/white-logo-01.89128677.svg";